import * as MakeBetActions from 'actions/MakeBet';

export default function(state = true, action = {}) {

    switch (action.type) {
        case MakeBetActions.MAKE_BET:
            return false;

        case MakeBetActions.SUCCESS_MAKE_BET:
        case MakeBetActions.FAILURE_MAKE_BET:
            return true;
    }

    return state;
}


// WEBPACK FOOTER //
// ./js/sport-betting/reducers/bettingAvailableReducer.js